import { render } from "./CourseRecords.vue?vue&type=template&id=3b585ab1"
import script from "./CourseRecords.vue?vue&type=script&lang=js"
export * from "./CourseRecords.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__